<template>
  <div class="userCenter banxin">
    <div class="leftMenu">
      <div class="leftMenuBox">
        <el-menu :default-active="defaultActive" active-text-color="#333333" text-color="#999999" router>
          <div class="mar-bot-40">
            <p class="fs22 bold">个人中心</p>
            <el-divider/>
            <el-menu-item class="flex-start" index="userInfo"><span class="title">个人资料</span></el-menu-item>
            <el-menu-item class="flex-start" index="contacts"><span class="title">委托方及联系人</span></el-menu-item>
          </div>
          <div class="mar-bot-40">
            <p class="fs22 bold">交易管理</p>
            <el-divider/>
            <el-menu-item class="flex-start" index="myOrder"><span class="title">委托单管理</span></el-menu-item>
            <el-menu-item class="flex-start" index="shareOrderInfo"><span class="title">关联委托单</span></el-menu-item>
            <!-- 模块暂不使用 -->
<!--            <el-menu-item class="flex-start" index="client"><span class="title">开票信息管理</span></el-menu-item>-->
            <el-menu-item class="flex-start" index="paymentInfo"><span class="title">委托单付款情况</span></el-menu-item>
          </div>
        </el-menu>
      </div>
    </div>
    <div class="userCenterInfo flex1">
      <router-view/>
    </div>
  </div>
</template>
<script>
export default {
  name: 'userCenter',
  data () {
    return {}
  },
  computed: {
    defaultActive: function () {
      // 当进入委托单详情页面时，委托单管理标题保持选中
      if(this.$route.path === '/orderDetail') {
        return this.$route.query.path.replace('/', '');
      } else return this.$route.path.replace('/', '');
    }
  },
  // 修改背景色
  beforeCreate () {
    document.querySelector('body')
      .setAttribute('style', 'background-color:#F6F6F8');
  },
  beforeDestroy () {
    document.querySelector('body')
      .removeAttribute('style');
  }
}
</script>
<style lang="scss" scoped>
.userCenter{
  display: flex;
  margin-top: 30px;
  margin-bottom: 100px;
  .leftMenu{
    width: 200px;
    margin-right: 20px;
    .el-menu{
      padding: 30px;
      border: 0;
      .el-menu-item{
        font-size: 18px;
        padding: 0 !important;
      }
      >>> .el-menu-item:focus, .el-menu-item:hover {
        background: none;
      }
      .is-active{
        font-weight: bold;
        color: #333333;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/index2.vue